<template>
  <v-dialog v-model="show" max-width="600" persistent>
    <v-card>
      <v-card-text>
        <v-stepper v-model="step" alt-labels elevation="0">
          <v-stepper-header
            color="#193D6E"
            class="mt-2 mb-2"
            elevation="0"
            style="
              justify-content: center;
              align-items: center;
              box-shadow: none;
            "
          >
            <v-stepper-step
              :complete="step > 1"
              step="1"
              color="#193D6E"
            ></v-stepper-step>
            <v-divider></v-divider>
            <v-stepper-step
              :complete="step > 2"
              step="2"
              color="#193D6E"
            ></v-stepper-step>
          </v-stepper-header>
          <v-stepper-items>
            <!-- Paso 1: Nueva contraseña -->
            <v-stepper-content step="1" class="pt-0">
              <div class="text-center mb-4">
                <div class="step-title">{{ texts.settings.resetPassword.resetPasswordTitle }}</div>
                <div class="step-subtitle mb-6">
                  {{ texts.settings.resetPassword.resetPasswordSubtitle }}
                </div>
              </div>
              <v-form
                ref="passwordForm"
                v-model="passwordValid"
                autocomplete="off"
              >
                <v-text-field
                  v-model="password"
                  :rules="passwordRules"
                  :label="texts.settings.resetPassword.resetPasswordNewPassword"
                  required
                  style="border-radius: 10px"
                  outlined
                  :type="showPassword ? 'text' : 'password'"
                  :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                  @click:append="showPassword = !showPassword"
                  autocomplete="new-password"
                  class="mb-2"
                />
                <v-text-field
                  v-model="passwordConfirm"
                  :rules="confirmPasswordRules"
                  :label="texts.settings.resetPassword.resetPasswordConfirmPassword"
                  required
                  style="border-radius: 10px"
                  outlined
                  :type="showPasswordConfirm ? 'text' : 'password'"
                  :append-icon="showPasswordConfirm ? 'mdi-eye' : 'mdi-eye-off'"
                  @click:append="showPasswordConfirm = !showPasswordConfirm"
                  autocomplete="new-password"
                  class="mb-2"
                />
              </v-form>
              <div class="d-flex justify-space-around pb-2">
                <v-btn
                  rounded
                  outlined
                  color="#0075B8"
                  @click="close"
                  elevation="3"
                  min-width="150px"
                  style="color: #0075B8; border-radius: 36px; border: 2px solid #0075B8; background-color: #fff; font-family: 'montserrat-semibold'; text-transform: none;"
                  >{{ texts.settings.resetPassword.cancel }}</v-btn
                >
                <v-btn
                  rounded
                  color="#0075B8"
                  :loading="isLoadingOtp"
                  :disabled="!passwordValid"
                  min-width="150px"
                  @click="goToOtp"
                  elevation="3"
                  style="
                    border-radius: 100px;
                    text-transform: none;
                    color: #fff;
                  "
                  >{{ texts.settings.resetPassword.continue }}</v-btn
                >
              </div>
            </v-stepper-content>
            <!-- Paso 2: OTP -->
            <v-stepper-content step="2" elevation="0" class="pt-0">
              <div class="text-center mb-4">
                <div class="step-title">{{ texts.settings.resetPassword.twoFactor.title }}</div>
              </div>
              <v-form ref="otpForm" v-model="otpValid" autocomplete="off">
                <v-otp-input
                  v-model="otp"
                  :rules="otpRules"
                  length="6"
                  type="number"
                  color="#193D6E"
                  class="otp-input-centered"
                  autocomplete="one-time-code"
                />
              </v-form>
              <div class="step-subtitle mb-6">
                {{ texts.settings.resetPassword.twoFactor.subtitle }}
              </div>
              <div class="d-flex justify-space-around pb-2">
                <v-btn
                  rounded
                  outlined
                  color="#0075B8"
                  @click="step = 1"
                  elevation="3"
                  min-width="150px"
                  style="color: #0075B8; border-radius: 36px; border: 2px solid #0075B8; background-color: #fff; font-family: 'montserrat-semibold'; text-transform: none;"
                  >{{ texts.settings.resetPassword.twoFactor.cancel }}</v-btn
                >
                <v-btn
                  rounded
                  color="#0075B8"
                  :loading="isLoadingResetPassword"
                  :disabled="!otpValid"
                  min-width="150px"
                  @click="resetPassword"
                  elevation="3"
                  style="
                    border-radius: 100px;
                    text-transform: none;
                    color: #fff;
                  "
                  >{{ texts.settings.resetPassword.twoFactor.validate }}</v-btn
                >
              </div>
            </v-stepper-content>
          </v-stepper-items>
        </v-stepper>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "DialogResetPassword",
  props: {
    value: Boolean,
    texts: Object
  },
  data() {
    return {
      step: 1,
      otp: "",
      otpValid: false,
      isLoadingOtp: false,
      password: "",
      passwordConfirm: "",
      passwordValid: false,
      isLoadingResetPassword: false,
      showPassword: false,
      showPasswordConfirm: false,
      otpRules: [
        (v) => !!v || "El código es obligatorio",
        (v) => /^\d{6}$/.test(v) || "El código debe tener 6 dígitos"
      ],
      passwordRules: [
        (v) => !!v || "La contraseña es obligatoria",
        (v) =>
          v.length >= 6 || "La contraseña debe tener al menos 6 caracteres",
        (v) =>
          /[!@#$%^&*(),.?":{}|<>]/.test(v) ||
          "Debe tener al menos un carácter especial"
      ],
      confirmPasswordRules: [
        (v) => !!v || "La confirmación es obligatoria",
        (v) => v === this.password || "Las contraseñas no coinciden"
      ]
    };
  },
  computed: {
    show: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      }
    }
  },
  watch: {
    value(val) {
      if (val) {
        this.resetForm();
      }
    },
    password(val) {
      // Para que la validación de confirmación se actualice
      this.$refs.passwordForm && this.$refs.passwordForm.validate();
    }
  },
  methods: {
    close() {
      this.show = false;
      this.resetForm();
    },
    resetForm() {
      this.step = 1;
      this.otp = "";
      this.otpValid = false;
      this.password = "";
      this.passwordConfirm = "";
      this.passwordValid = false;
      this.isLoadingOtp = false;
      this.isLoadingResetPassword = false;
      this.showPassword = false;
      this.showPasswordConfirm = false;
    },
    goToOtp() {
      if (!this.$refs.passwordForm.validate()) return;
      // Enviar el OTP al correo del usuario logueado
      this.isLoadingOtp = true;
      DB.get(
        `${URI}/api/v1/${this.$store.state.language}/authenticator/resetPassword`,
        {
          headers: {
            Authorization: this.$store.state.sToken
              ? `Bearer ${this.$store.state.sToken}`
              : ""
          }
        }
      )
        .then((response) => {
          if (!response.data.success) {
            this.$parent.mixError(response.data.message, response.status);
          } else {
            this.step = 2;
          }
        })
        .catch((error) => {
          this.$parent.mixError(
            error.response.data.message,
            error.response.status
          );
        })
        .finally(() => {
          this.isLoadingOtp = false;
        });
    },
    resetPassword() {
      if (!this.$refs.otpForm.validate()) return;
      this.isLoadingResetPassword = true;
      // Primero validar el OTP
      const payloadOtp = { sCode: this.otp };
      DB.post(
        `${URI}/api/v1/${this.$store.state.language}/authenticator/verify`,
        payloadOtp,
        {
          headers: {
            Authorization: this.$store.state.sToken
              ? `Bearer ${this.$store.state.sToken}`
              : ""
          }
        }
      )
        .then((response) => {
          if (!response.data.success) {
            this.$parent.mixError(response.data.message, response.status);
            this.isLoadingResetPassword = false;
          } else {
            // Si el OTP es válido, cambiar la contraseña
            const payloadResetPassword = {
              sPassword: this.password,
              sConfirmPassword: this.passwordConfirm
            };
            DB.put(
              `${URI}/api/v1/${this.$store.state.language}/recovery-passwords`,
              payloadResetPassword,
              {
                headers: {
                  Authorization: this.$store.state.sToken
                    ? `Bearer ${this.$store.state.sToken}`
                    : ""
                }
              }
            )
              .then((response) => {
                if (!response.data.status) {
                  this.$parent.mixError(response.data.message, response.status);
                } else {
                  this.$parent.mixSuccess(
                    response.data.message,
                    response.status
                  );
                  this.close();
                  this.$emit("refresh");
                }
              })
              .catch((error) => {
                this.$parent.mixError(
                  error.response.data.message,
                  error.response.status
                );
              })
              .finally(() => {
                this.isLoadingResetPassword = false;
              });
          }
        })
        .catch((error) => {
          this.$parent.mixError(
            error.response.data.message,
            error.response.status
          );
          this.isLoadingResetPassword = false;
        });
    }
  }
};
</script>

<style scoped>
.step-title {
  font-size: 1.5rem;
  font-weight: bold;
  margin-bottom: 0.5rem;
}
.step-subtitle {
  font-size: 1rem;
  color: #444;
  margin-bottom: 1.5rem;
}
.otp-input-centered {
  display: flex;
  justify-content: center;
  margin-bottom: 1.5rem;
}
.v-btn[outlined] {
  border: 1.5px solid #193d6e;
  color: #193d6e;
}
.v-btn {
  min-width: 140px;
  font-size: 1rem;
  font-weight: 500;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(25, 61, 110, 0.08);
}
.v-text-field input {
  font-size: 1.1rem;
  padding: 18px 12px;
}
</style>
